<template>
  <el-dialog  :visible.sync="showDialogVal" append-to-body custom-class="product-options-style">
    <div slot="title" class="verticallyCenter dialog-title">
      <span class="dialog-name">选择样式</span>
      <div class="flex1 textCenter">
        <el-input class="search-inp " placeholder="搜索" v-model="searchName"  @focus="getFocus($event)" @blur="blurEvent($event)" @keydown.native="keyDownEvent">
          <template slot="suffix">
            <span class="icon icon-portal-search" @click="selectTemplate"></span>
          </template>
        </el-input>
      </div>
    </div>
    <div class="list-box">
      <div class="left">
        <ul class="left-types-list">
          <li
            class="types-list-li"
            v-for="(type, index) in typeLists"
            :key="index"
            @click="changeStyleType(type.encId, index)"
            :class="activeId === index ? 'active' : ''"
          >
            <div class="verticallyCenter types-list-li-content">
              <span class="flex1 font600">{{ type.name }}</span>
              <span class="count font400">{{ type.count }}</span>
            </div>
            <span class="topping-style" v-if="collectTypeId === type.id && index === 0 "></span>
          </li>
        </ul>
      </div>
      <div class="right" ref="styleWrap">
        <el-scrollbar ref="scrollbar" style="height: 100%">
          <div class="empty-data" v-if="styleDatas.length === 0">
            <span v-if="loadingData" class="icon-portal-loading1"></span>
            <p v-else>没有数据</p>
          </div>
          <div v-else-if="styleType === 'local' && !styleId" class="style-datas" ref="styleDatas">
            <waterfall :col="col" :data="styleDatas">
              <div
                class="style-data-li"
                v-for="(item, index) in styleDatas"
                :key="index"
                @click="selectLocalStyle(item, index)"
              >
                <img
                  v-if="activeIndexVal === index && false"
                  class="checked"
                  src="../../../assets/images/icon-checked.png"
                  alt=""
                />
                <div class="img-box"><img :src="styleImgs[index]" alt="" /></div>
                <p class="overflowHid1" v-if="styleType === 'local'">样式{{ index + 1 }}</p>
              </div>
            </waterfall>
          </div>
          <div v-else class="style-datas" ref="styleDatas">
            <waterfall :col="col" :data="styleDatas" :lazy-distance="20" :load-distance="200">
              <div
                class="style-data-li"
                v-for="(item, index) in styleDatas"
                :key="index"
                @click="selectStyle(item, index)"
                :class="isActive(item) ? 'active' : ''"
              >
                <img
                  v-if="options.encId === item.encId && false"
                  class="checked"
                  src="../../../assets/images/icon-checked.png"
                  alt=""
                />
                <div class="img-box"><img :src="item.cover ? item.cover : defaultImg" alt="" /></div>
                <span
                  v-if="hasDelPermission && styleDatas.length > 0 && item.encId"
                  class="delete-icon"
                  @mousedown.stop
                  @click.stop="delComponent(item)"
                ><i class="icon icon-portal-delete"></i
                ></span>
                <div class="verticallyCenter template-info">
                  <p class="overflowHid1 flex1">{{ item.name || item.title }}</p>
                  <span v-if="item.typeId !== collectTypeId" class="component-name-box">{{getStyleNo(item)}}</span>
                  <!--                  二期可能考虑缩略图，编号等修改 下面代码未完-->
                  <!--                  <div class="component-name-box">-->
                  <!--                    <span class="component-name-edit" v-show="!showEditNo" @click.stop="editComponentNo(item)">-->
                  <!--                       <span class="component-name">{{item.pid}}</span>-->
                  <!--                       <span class="icon-portal-edit"></span>-->
                  <!--                    </span>-->
                  <!--                    <input-->
                  <!--                      v-show="showEditNo"-->
                  <!--                      class="component-name-inp"-->
                  <!--                      type="text"-->
                  <!--                      ref="componentNameInp"-->
                  <!--                      :value="item.pid"-->
                  <!--                      @click.stop-->
                  <!--                      @focus="getComponentNoFocus($event)"-->
                  <!--                      @blur="showEditNo = false"-->
                  <!--                    />-->
                  <!--                </div>-->
                </div>
              </div>
            </waterfall>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import instance from "../../../interceptor"
import { getSystemModulesList } from "@/utils/initEv.js"


export default {
  name: "styles-list",
  props: {
    typeId: {
      type: [Number, String]
    },
    allStyles: {
      type: Array,
      required: true
    },
    showDialog: {
      type: Boolean,
      default: true
    },
    styleTypeName: {
      type: String,
      required: true
    },
    styleType: {
      type: String
    },
    styleImgs: {
      type: Array
    },
    activeIndex: {
      type: [Number, String],
      default: 0
    },
    options: {
      type: Object,
      required: true
    },
    localStylesLen: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    hasDelPermission() {
      let userPermissionCode = this.$store.state.states.userPermission || ""
      return Array.isArray(userPermissionCode) && userPermissionCode?.indexOf(12) > -1 ? true : false
    },
    localStyles() {
      let styles = []
      this.allStyles.forEach(item => {
        if (item.options.isDefaultComponent) {
          styles.push(item)
        }
      })
      return styles
    },
    showDialogVal: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit("update:showDialog", val)
      }
    },
    activeIndexVal: {
      get() {
        return this.activeIndex
      },
      set(val) {
        this.$emit("update:activeIndex", val)
      }
    },
    isActive() {
      return function (item) {
        let active = false
        if (this.options) {
          if (item.encId && this.options.encId === item.encId) active = true
          else if (item.options?.encId && this.options.encId === item.options.encId) active = true
          else if (!this.options.encId && !item.encId && !item.options.encId && this.options.styleId === item.options?.styleId) active = true
        }
        return active
      }
    },
    collectTypeId(){
      return this.typeLists.find(item=>item.name?.indexOf("我的")>-1)?.id
    },
    getStyleNo(){
      return function(styles){
        const DEFAULTLEN = 4
        let prefixO =''
        if(styles.seq){
          const seq = styles.seq.toString()
          // 不足四位需要补齐
          const diffLen = DEFAULTLEN - seq.length
          for(let i=0;i<diffLen;i++){
            prefixO=prefixO+'0'
          }
        }else{
          // 本地数据不展示
          return ''
        }
        let prefix =  this.typeLists.find(item=>item.id === styles.typeId)?.prefix
        return `${prefix}${prefixO}${styles.seq}`
      }
    },
  },
  data() {
    return {
      defaultImg: require("../../../assets/images/default_image_home.png"),
      // styleDatas: this.allStyles,
      styleDatas: [],
      activeId: 1,
      // styleId: this.typeId,
      styleId: undefined,
      typeLists: [],
      // allStyleLen: this.allStyles.length,
      allStyleLen: 0,
      totalPage: undefined, //总页码
      curPage: 1, // 当前的页码
      pageNum: 20, //每页数量
      col: 3,
      timer: null,
      loadingData: false,
      searchName:'',
      showEditNo: false,
      isFocus: false,
      allTypeIndex:0
    }
  },
  mounted() {
    this.getAllStyles()
    // document.addEventListener("keydown", this.keyDownEvent)
    this.$nextTick(() => {
      this.listenerScroll()
      setTimeout(()=>{
        this.isAutoUpdateData()
      },1000)
    })
    this.styleCol()
    window.addEventListener("resize", this.styleCol)
  },
  beforeDestroy() {
    this.timer = null
    window.removeEventListener("resize", this.styleCol)
    // document.removeEventListener("keydown", this.keyDownEvent)
  },
  methods: {
    getFocus(event){
      this.isFocus = true
      event.currentTarget.select()
    },
    blurEvent(){
      this.isFocus = false
    },
    keyDownEvent(){
      let key = window.event.keyCode
      //enter键  待完善
      console.log("keyDownEvent")
      if (key === 13 ) {
        this.selectTemplate()
      }
    },
    selectTemplate(){
      this.curPage = 1
      // 搜索的时候需要重新调用分类统计接口
      this.styleDatas=[]
      this.getAllStyles(true)
    },
    // editComponentNo(item){
    //   this.showEditNo = true
    // },
    // getComponentNoFocus(){
    //   event.currentTarget.select()
    //   this.showEditNo = true
    // },
    async getAllStyles(isSearch) {
      await this.getTypeList()
      if (!this.styleId) {
        let menu =
          this.request_prefix === "bigScreen"
            ? this.$store.state.bigScreenMenu.menu
            : this.request_prefix === "appStage"
            ? this.$store.state.appMenu.menu
            : this.$store.state.menu.menu
        let moduleTypes = menu.moduleTypes
        console.log("moduleTypes",moduleTypes)
        let module = moduleTypes.find(item => item.name === this.styleTypeName)
        this.styleId = module?.encId
        console.log("this.typeLists",this.typeLists)
        // this.styleId = this.typeLists.find(item=>item.name?.indexOf("我的")>-1)?.encId
      }
      if (!this.styleId) {
        return
      }
      this.loadingData = true
      let res = await this.$API.queryComponentList({
        typeId: this.styleId,
        // p2: isSearch? 20 : 20,
        p2: 20,
        lsc: true,
        k: this.searchName
      })
      this.loadingData = false
      this.totalPage = res?.data?.data?.PageInfo?.pages
      if(!isSearch){
        // 第一次使用的组件选中时的数据
        this.allStyleLen = res?.data?.data?.PageInfo?.total + this.localStylesLen
      }else{
        this.allStyleLen = res?.data?.data?.PageInfo?.total
      }
      this.styleDatas = res?.data?.data?.PageInfo?.list
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.isAutoUpdateData()
        },1000)
      })
    },
    async getTypeList() {
      this.typeLists = [
        {
          name: "全部",
          // encId: this.styleId,
          encId: this.typeId,
          count: this.allStyleLen
        }
      ]
      if (!this.typeId) {
        let menu =
          this.request_prefix === "bigScreen"
            ? this.$store.state.bigScreenMenu.menu
            : this.request_prefix === "appStage"
            ? this.$store.state.appMenu.menu
            : this.$store.state.menu.menu
        let moduleTypes = menu.moduleTypes
        let module = moduleTypes.find(item => item.name === this.styleTypeName)
        this.typeId = module?.encId
      }
      if (this.styleType === "local" && !this.styleId) {
        return this.typeLists
      }
      await this.$API
        .queryComponentTypeTree({
          pid: this.typeId,
          countSub: true,
          k: this.searchName
        })
        .then(res => {
          this.typeLists = this.typeLists.concat(res.data.data.list)
          // 将我的收藏放到第一个
          let myCollectType = this.typeLists.findIndex(item=>item.name?.indexOf("我的")>-1)
          if(myCollectType> -1){
            this.typeLists.splice(0,0,this.typeLists[myCollectType])
            this.typeLists.splice(myCollectType+1,1)
            this.allTypeIndex = 1
          }
          // 统计全部的数量
          let allCount = 0
          this.typeLists.forEach(list=>{
            if(list.name.indexOf("我的") === -1 && list.name.indexOf("全部") === -1){
              allCount+= list.count
            }
          })
          this.typeLists[this.allTypeIndex].count = allCount
          return this.typeLists
        })
    },
    listenerScroll() {
      let _this = this
      _this.$refs.scrollbar.wrap.onscroll = e => {
        let height = e.target.scrollHeight - e.target.clientHeight
        if (
          (height == e.target.scrollTop || height - e.target.scrollTop === 1 || height - e.target.scrollTop < 1) &&
          height != 0 &&
          _this.curPage < _this.totalPage
        ) {
          _this.curPage = _this.curPage + 1
          _this.$API
            .queryComponentList({
              typeId: _this.styleId,
              p2: _this.pageNum,
              p: _this.curPage,
              // lsc: _this.styleId === _this.typeLists[0].encId ? true : false,
              lsc: _this.styleId === _this.typeId ? true : false,
              k: this.searchName
            })
            .then(res => {
              let nowDatas = [].concat(_this.styleDatas)
              if (_this.curPage === 2 && nowDatas.length > 20) {
                nowDatas.splice(20, nowDatas.length)
              }
              _this.styleDatas = nowDatas.concat(res.data?.data?.PageInfo?.list)
            })
        }
      }
    },
    delComponent(param) {
      const self = this
      if (param.encId) {
        this.$confirm("确认删除吗？", "", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          showClose: false,
          dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
          iconClass: "bigScreen_confirm_icon el-icon-warning",
          cancelButtonClass: "bigScreen_confirm_cancel_button",
          confirmButtonClass: "bigScreen_confirm_button",
          customClass: "bigScreen_confirm custom_warning_dialog"
        })
          .then(() => {
            instance
              .post(`v2/${param.encId}/remove`)
              .then(() => {
                getSystemModulesList.call(this, this.typeId)
                this.changeStyleType(this.styleId, this.activeId)
                // this.allStyleLen = this.allStyleLen - 1
                // 不重新获取接口，直接修改数量
                // this.typeLists[1].count = this.allStyleLen
                //  删除收藏的组件时，总数不变
                let curType = this.typeLists[this.activeId]
                if(!(curType && curType.name && curType.name.indexOf("我的")===0)){
                  // 排除收藏分类
                  this.typeLists[this.allTypeIndex].count = this.typeLists[1].count - 1
                }
                if (this.activeId !== this.allTypeIndex) {
                  this.typeLists[this.activeId].count--
                }else{
                  // 在全部分类下进行删除，需要把对应的分类统计数进行减1
                  let curTypeIndex = this.typeLists.findIndex(list=>list.id === param.typeId)
                  curTypeIndex > -1 && this.typeLists[curTypeIndex].count--
                }
              })
              .catch(err => {})
          })
          .catch(() => {})
      }
    },
    changeStyleType(styleId, index) {
      this.activeIndexVal = undefined
      this.activeId = index
      this.styleId = styleId
      this.styleDatas = []
      this.loadingData = true
      let styleDatas =[]
      // if (styleId === this.typeLists[0].encId) {
      //   styleDatas = JSON.parse(JSON.stringify(this.localStyles))
      // } else {
      //   styleDatas = []
      // }
      this.curPage = 1
      this.$API
        .queryComponentList({
          typeId: this.styleId,
          p2: this.pageNum,
          p: this.curPage,
          // lsc: index === 0 ? true : false,
          lsc:  styleId === this.typeId ? true : false,
          k: this.searchName
        })
        .then(res => {
          this.styleDatas = styleDatas.concat(res.data?.data?.PageInfo?.list)
          this.totalPage = res.data?.data?.PageInfo?.pages
          this.loadingData = false
          // 判断当前样式数量是否小于总数，如果小于总数，并且渲染高度小于弹框高度，此时不能触发滚动加载下一页，需要自动加载下一页
          this.$nextTick(()=>{
            setTimeout(()=>{
              this.isAutoUpdateData()
            },1000)
          })

        })
    },
    isAutoUpdateData(){
      // 后端接口已经调整，全部中不再包含我的样式，所以暂时屏蔽，测试无问题可删除
      if(this.styleDatas.length === 0){
        return
      }
      const total =  this.typeLists[this.activeId].count
      if(this.styleDatas.length === total ){
        return
      }
      const styleHeight = this.$refs.styleDatas.getBoundingClientRect().height
      const styleWrapHeight = this.$refs.styleWrap.getBoundingClientRect().height - 15  // 底部有15px的空白
      if(styleHeight < styleWrapHeight){
        this.curPage ++
        this.$API
          .queryComponentList({
            typeId: this.styleId,
            p2: this.pageNum,
            p: this.curPage,
            lsc:  this.styleId === this.typeId ? true : false,
            k: this.searchName
          })
          .then(res => {
            this.styleDatas = this.styleDatas.concat(res.data?.data?.PageInfo?.list)
            setTimeout(()=>{
              this.isAutoUpdateData()
            },1000)
          })
      }
    },
    selectStyle(item, index) {
      console.log("index :>>", index)
      this.activeIndexVal = index
      let options
      if (item.options) {
        item.options.componentTypeId = this.styleId
        options = item.options
      } else {
        options = item
        options.options = {}
        options.name = this.styleTypeName
        options.options.componentTypeId = this.styleId
      }
      this.$emit("changeStyle", options, index)
      this.showDialogVal = false
    },
    selectLocalStyle(item, index) {
      this.activeIndexVal = index
      this.$emit("changeStyle", item, index)
      // 延时500ms 关闭弹框
      this.timer = setTimeout(() => {
        this.showDialogVal = false
      }, 500)
    },
    styleCol() {
      var bodyW = document.body.clientWidth
      if (bodyW < 960) {
        this.col = 1
      } else if (bodyW < 1284 && bodyW >= 960) {
        this.col = 2
      } else if (bodyW < 1608 && bodyW >= 1284) {
        this.col = 3
      } else if (bodyW > 1608) {
        this.col = 4
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-title{
  padding: 0  200px 0 0;
  box-sizing: border-box;
}
.empty-data {
  padding: 200px 0;
  font-size: 14px;
  text-align: center;
}
.dialog-name{
  font-size: 16px;
  font-weight: 600;
  color: rgba(0,0,0,0.8);
  width: 200px;
}
.component-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
}
.component-name-inp,
.component-name-text {
  padding: 6px 8px;
  height: 30px;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.component-name-edit{
  height: 30px;
  line-height: 26px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}
.component-name-box{
  line-height: 20px;
  padding: 10px 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  text-align: right;
}
.component-name-box span{
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}
.component-name-box,
.component-name-text{
  display: inline-block;
  width: 50px;
}
.component-name-edit,
.component-name-inp{
  width: 100%;
}
.component-name-text {
  width: calc(100% - 56px);
}
::v-deep .el-dialog .el-dialog__headerbtn{
  top:19px;
}
::v-deep .search-inp{
  width: 400px;
  background-color: #F3F3F3;
  border:none;
  border-radius: 8px;
  .icon{
    color: rgba(0,0,0,0.4);
  }
  .el-input__suffix-inner{
    line-height: 30px;
    cursor: pointer;
  }
}
.icon-portal-loading1 {
  display: inline-block;
  transform: rotate(90deg);
  font-size: 24px;
  color: var(--topOperationAColor);
  vertical-align: middle;
  animation: rotation 1s linear infinite;
  &:before {
    color: var(--topOperationAColor);
  }
}
::v-deep .product-options-style {
  margin-top: 75px !important;
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .product-options-style .el-dialog__body {
  padding: 0;
  box-sizing: border-box;
}
.left {
  width: 200px;
  padding: 16px;
  box-sizing: border-box;
  overflow-y: auto;
  border-right: 1px solid #ededed;
}
.list-box {
  display: flex;
  align-items: stretch;
  min-height: 200px;
  height: calc(100vh - 200px);
  flex-wrap: wrap;
}
.style-datas {
  padding: 12px;
  font-size: 0;
}
.style-data-li {
  position: relative;
  // height: 150px;
  min-height: 44px;
  width: 300px;
  margin: 12px 4px;
  display: inline-block;
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0px 4px 16px 4px rgba(0, 0, 0, 0.03), 0px 4px 8px rgba(0, 0, 0, 0.02),
  0px 2px 4px -4px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  &.active {
    outline: 2px solid var(--themeColor);
    border: 1px solid var(--themeColor);
  }
  &:hover {
    outline: 2px solid var(--themeColorHover);
    border: 1px solid var(--themeColorHover);
    .delete-icon {
      display: block;
    }
  }
  p {
    opacity: 1;
  }
  img.checked {
    position: absolute;
    top: -1px;
    right: -1px;
  }
  .img-box {
    /*height: 162px;*/
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(245, 246, 248, 1);
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    background-clip: padding-box;
    img {
      width: 100%;
      height: auto;
    }
  }
  .delete-icon {
    position: absolute;
    display: none;
    top: 8px;
    right: 8px;
    border-radius: 6px;
    width: 26px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    background-color: var(--rootBgColor);
    color: var(--iconColor);
    font-size: 12px;
    border:1px solid var(--inputBg);
  }
  p {
    background: rgba(255, 255, 255, 0.8);
    //backdrop-filter: blur(16px);
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 0;
    box-sizing: border-box;
    color: var(--textColor);
  }
}
.right {
  flex: 1;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
  overflow: auto;
}
.template-info{
  padding: 0 16px;
  border-top: 1px solid rgba(233, 233, 233, 1);
}
.left-types-list {
  .types-list-li {
    font-weight: 500;
    font-size: 14px;
    line-height: 40px;
    padding: 0 10px 0 16px;
    cursor: pointer;
    border-radius: 8px;
    margin-bottom: 4px;
    .types-list-li-content{
      white-space: nowrap; /*内容超宽后禁止换行显示*/
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /*文字超出部分以省略号显示*/
    }
    &:hover {
      background-color: #f0f2f7;
    }
    &.active {
      background: var(--themeColorSelectBg);
      color: var(--themeColor);
    }
    &:nth-child(1){
      position: relative;
    }
    &:nth-child(2){
      margin-top: 24px;
    }
  }
}
::v-deep .product-options-style.el-dialog {
  padding: 0;
  box-sizing: content-box;
}
.topping-style{
  position: absolute;
  bottom: -12px;
  left: 16px;
  right: 10px;
  content: " ";
  border-bottom: 1px solid rgb(240, 240, 240);
}
@media screen and (min-width: 1921px) {
  ::v-deep .product-options-style.el-dialog {
    width: 1720px;
  }
  .style-data-li {
    width: 350px;
  }
}
@media screen and (min-width: 1608px) and (max-width: 1920px) {
  ::v-deep .product-options-style.el-dialog {
    width: 1520px;
  }
}
@media screen and (min-width: 1284px) and (max-width: 1607px) {
  ::v-deep .product-options-style.el-dialog {
    width: 1196px;
  }
}
@media screen and (min-width: 960px) and (max-width: 1283px) {
  ::v-deep .product-options-style.el-dialog {
    width: 872px;
  }
}
@media screen and (max-width: 959px) {
  ::v-deep .product-options-style.el-dialog {
    width: 548px;
  }
  ::v-deep .search-inp{
    width: 240px;
  }
  .dialog-title{
    padding-right: 130px;
  }
}
</style>
